import { defineRule } from 'vee-validate'
import { addMethod, string } from 'yup'

import * as rules from '@vee-validate/rules'

export default defineNuxtPlugin(() => {
  const castRules: Record<string, any> = rules
  Object.keys(castRules)
    .filter(k => k !== 'default')
    .forEach((ruleKey) => {
      defineRule(ruleKey, castRules[ruleKey])
      // figure out how to cast rules[rule] to remove castRules
      // defineRule(rule, rules[rule])
    })
  defineRule('postalCode', zipRule)
  // defineRule('validExpiry', zipRule)
  addCustomMethods()
})
function addCustomMethods() {
  // todo figure out how to use t() here
  addMethod(string, 'postalCode', function postalCode(errorMsg: string = 'ENTER_VALID_POSTAL_CODE') {
    return this.matches(/^[0-9-]{5,}$/gi, errorMsg)
  })

  addMethod(string, 'validExpiry', function validExpiry(errorMsg: string = 'FIELD_REQ') {
    return this.test('validExpiry', errorMsg, function (value) {
      const { path, createError } = this
      if (!value) {
        return createError({ path, message: errorMsg ?? 'FIELD_REQ' })
      } else if (value.length < 5) { // 4 digits + 1 / ex: 02/24
        return createError({ path, message: 'INCOMPLETE_EXPIRY' })
      }
      const endOfMonth = new Date()
      const dateEntered = new Date()
      const minYear = new Date().getFullYear() + ''
      function getLastDayOfMonth(
        month = new Date().getMonth(),
        year = new Date().getFullYear(),
      ) {
        return new Date(year, month + 1, 0).getDate()
      }
      const parts = value.split('/')
      const month = parts[0]
      const year = parts[1]
      const yearEntered = `${minYear[0]}${minYear[1]}${year}`
      const lastDayOfMonth = getLastDayOfMonth()
      endOfMonth.setDate(lastDayOfMonth)
      endOfMonth.setHours(11, 59, 59)
      // january = 0
      dateEntered.setMonth(+month - 1, 1)
      dateEntered.setDate(
        getLastDayOfMonth(dateEntered.getMonth(), dateEntered.getFullYear()),
      )
      dateEntered.setFullYear(+yearEntered)
      dateEntered.setHours(11, 59, 59)
      if (+yearEntered < +minYear) {
        return createError({ path, message: 'INVALID_EXPIRY_YEAR' })
      } else if (dateEntered < endOfMonth) {
        // expiryErr.value = ''
        return createError({ path, message: 'INVALID_EXPIRY_MONTH' })
      }
      return true
    })
  })
}
function zipRule(value: string) {
  return /^[0-9-]{5,}$/gi.test(value) || 'ENTER_VALID_POSTAL_CODE'
}
